/**
 * Whether a configuration row is in service.
 *
 * There is no editing lifecycle any more — a row that saved is one that passed
 * validation, so there is no draft to distinguish from a published thing. What
 * is left is the single question the runtime actually asks: will this be used?
 *
 * `isActive` is absent on rows written before the field existed, and those were
 * in service. Treating a missing value as inactive would retire them on sight,
 * so only an explicit `false` reads as inactive.
 */
export const isRowActive = (row: { isActive?: boolean | null }): boolean =>
  row.isActive !== false;
